import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

// Swiper v9+ prefers modules in config, but this also works:
Swiper.use([Navigation, Pagination, Autoplay]);

export default () => {
  const nodeSelectors = {
    container: '[js-search-slider="container"]',
    slider: '[js-search-slider="slider"]',
    prev: '[js-search-slider="prev"]',
    next: '[js-search-slider="next"]',
    pagination: '[js-search-slider="pagination"]',
  };

  // Keep instances so we can destroy them before re-init
  const instances = new Map(); // key: containerEl, value: swiper instance

  function init(root = document) {
    initSlider(root);
  }

  function destroy(root = document) {
    const containers = root.querySelectorAll(nodeSelectors.container);
    containers.forEach((container) => {
      const inst = instances.get(container);
      if (inst) {
        inst.destroy(true, true);
        instances.delete(container);
      }
    });
  }

  function initSlider(root = document) {
    const slidersContainers = root.querySelectorAll(nodeSelectors.container);

    slidersContainers.forEach((container) => {
      const sliderEl = container.querySelector(nodeSelectors.slider);
      if (!sliderEl) return;

      // If re-initting, destroy existing instance first
      const existing = instances.get(container);
      if (existing) {
        existing.destroy(true, true);
        instances.delete(container);
      }

      const swiper = new Swiper(sliderEl, {
        slidesPerView: 1.2,
        spaceBetween: 15,
        loop: false,
        autoplay: {
          delay: 2500,
          disableOnInteraction: true,
          pauseOnMouseEnter: true,
        },
        watchSlidesProgress: true,
        speed: 500,
        navigation: {
          nextEl: container.querySelector(nodeSelectors.next),
          prevEl: container.querySelector(nodeSelectors.prev),
        },
        pagination: {
          el: container.querySelector(nodeSelectors.pagination),
          type: 'progressbar',
        },
        breakpoints: {
          768: { spaceBetween: 20, slidesPerView: 2 },
          1024: { spaceBetween: 20, slidesPerView: 3 },
        },
      });

      instances.set(container, swiper);
    });
  }

  return Object.freeze({
    init,
    destroy,
  });
};